import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import React from 'react';

import { DOC_TYPE_ALIAS } from '../../../config/helpers';

import Picture from '../Picture';

const propTypes = exact({
  description: PropTypes.string,
  documentTypeAlias: PropTypes.string.isRequired,
  image: PropTypes.object,
  status: PropTypes.string,
  title: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
});

const defaultProps = {
  description: null,
  image: null,
  status: null,
};

function FeaturedPage(props) {
  return (
    <article className={`FeaturedItem ${props.status}`}>
      {props.image && (
        <Picture
          {...props.image}
          sizes={[
            [100, '640'], // from 0
            [100, '640'], // from 480
            [100, '640'], // from 768
            [100, '640'], // from 1024
            [100, '640'], // from 1440
          ]}
          className="FeaturedItem_figure"
          loading={props.index === 0 ? 'eager' : 'lazy'}
        />
      )}
      <div className="FeaturedItem_container">
        <div className="FeaturedItem_content">
          {props.documentTypeAlias === DOC_TYPE_ALIAS.NEWS_ARTICLE && (
            <h3 className="FeaturedItem_tournament FeaturedItem_animation">News</h3>
          )}
          <h2 className="FeaturedItem_title FeaturedItem_animation">{props.title}</h2>
          {props.description && (
            <div className="FeaturedItem_description FeaturedItem_animation">
              {props.description}
            </div>
          )}
          <div className="FeaturedItem_cta FeaturedItem_animation">
            <a href={props.url} className="FeaturedItem_button Button Button-ghost">
              <span className="Button_text">Read more</span>
            </a>
          </div>
        </div>
      </div>
    </article>
  );
}

FeaturedPage.propTypes = propTypes;
FeaturedPage.defaultProps = defaultProps;

export default FeaturedPage;
